module.exports = __webpack_public_path__ + "img/utility-pole-double.9618203a.svg";